export const DEFAULT_FORAGE_CONFIG = {
    brain: 'table',
    gridSize: 12,
    foodCount: 4,
    vision: 5,
    foodReward: 14,
    movementCost: 1,
    exploration: 0.24,
    learningRate: 0.32,
    discount: 0.92,
    trainingRate: 2,
    seed: 1204,
};

export const FORAGE_BRAINS = [
    {
        id: 'table',
        name: 'Q-table',
        description: 'Memorizes one value for every observation and action.',
        architecture: '61 observations × 4 actions',
    },
    {
        id: 'neural',
        name: 'Neural Q-network',
        description: 'Learns a compact function that generalizes across similar observations.',
        architecture: '5 inputs → 12 hidden → 4 actions',
    },
];

export const TRAINING_STEPS = [0, 80, 320, 1200, 3000, 6500];

export const FORAGE_CONTROLS = [
    {
        key: 'foodCount',
        label: 'Food',
        min: 1,
        max: 10,
        step: 1,
        format: (value) => value,
    },
    {
        key: 'vision',
        label: 'Vision',
        min: 1,
        max: 11,
        step: 1,
        format: (value) => `${value} cells`,
    },
    {
        key: 'foodReward',
        label: 'Food reward',
        min: 4,
        max: 24,
        step: 1,
        format: (value) => `+${value}`,
    },
    {
        key: 'movementCost',
        label: 'Movement cost',
        min: 0.5,
        max: 2,
        step: 0.1,
        format: (value) => `−${Number(value).toFixed(1)}`,
    },
    {
        key: 'exploration',
        label: 'Exploration',
        min: 0.02,
        max: 0.8,
        step: 0.01,
        format: (value) => `${Math.round(value * 100)}%`,
    },
    {
        key: 'learningRate',
        label: 'Learning rate',
        min: 0.05,
        max: 0.8,
        step: 0.01,
        format: (value) => Number(value).toFixed(2),
    },
];

export const INITIAL_FORAGE_SNAPSHOT = {
    gridSize: DEFAULT_FORAGE_CONFIG.gridSize,
    episodes: 0,
    steps: 0,
    averageReward: 0,
    averageFood: 0,
    rewardHistory: [],
    evaluationScore: 0,
    randomBaseline: 0,
    evaluationHistory: [],
    learnedStates: 0,
    totalStates: 530,
    goalDirected: 0,
    goalDirectedHistory: [{ episode: 0, value: 0 }],
    randomPolicyBaseline: 0,
    brain: DEFAULT_FORAGE_CONFIG.brain,
    brainSize: 244,
    mode: 'learn',
    paused: false,
    evaluation: {
        agent: { x: 5, y: 6, energy: 30, direction: 1 },
        foods: [
            { x: 2, y: 2 },
            { x: 9, y: 3 },
            { x: 3, y: 9 },
            { x: 9, y: 9 },
        ],
        trail: [],
        steps: 0,
        reward: 0,
        foodCollected: 0,
        complete: false,
    },
};
